import React from 'react';
import { Link } from 'react-router-dom';
import { PATHS } from '@/constants';

const NotFoundErrorPageBody: React.FC = () => {
  return (
    <div>
      <h1>404 - Page Not Found</h1>
      <p>
        The page you are looking for might have been removed, had its name
        changed, or is temporarily unavailable.
      </p>
      <Link to={PATHS.APPLICANT.DASHBOARD}>Go to Home</Link>
    </div>
  );
};

export default NotFoundErrorPageBody;
